var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head-line"},[_c('div',{staticClass:"hl-line"}),_c('div',{staticClass:"hl-txt"},[_vm._v(_vm._s(_vm.lineText))])])}
var staticRenderFns = []

export { render, staticRenderFns }